import { Button, Divider, Typography } from '@mui/material';
import React from 'react'
import nlogo from '../../assets/images/nlogo.png'
import { useNavigate } from 'react-router-dom';
import Languages from '../../components/Languages';
import { useTranslation } from 'react-i18next';

function PreLogin() {
    const { t } = useTranslation('global');
    const navigate = useNavigate();
    const handleLogin = () => {
        navigate('/login');
    }

    return (
        <div className='prelogin'>
            <div className='prehead'>
                <div></div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Languages />
                    <Button sx={{ width: 100 }} variant="contained" className='btn' onClick={handleLogin}>  {t('login')}</Button>
                </div>
            </div>

            <div className='prelogo'>
            <img 
                    src={nlogo} 
                    alt="Logo"
                    style={{
                        width: '20%',      // Adjust image width to 80% of its container (you can change this value)
                        maxWidth: '200px', // Ensures the image never exceeds 400px in width
                        height: 'auto',    // Maintains aspect ratio
                        display: 'block',  // Removes any extra space below the image
                        margin: '0 auto',  // Centers the image horizontally
                    }} 
                />
                <Typography sx={{ marginTop: '55px', fontSize: '20px', fontWeight: 'bold' }} component={'div'}>Welcome</Typography>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <Divider sx={{ border: '1.3px solid #40a8dc', width: '350px' }} />
                </div>
            </div>

            <div></div>
        </div>
    )
}

export default PreLogin